import React from 'react';
import { Provider } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import HomePage from '../containers/HomePage';
import CartPage from '../containers/CartPage';
import Lookup from '../containers/HomePage/Lookup';
import OrderConfirmPage from '../containers/OrderConfirmPage';
import ContactUsStaticPage from './StaticPages/ContactUsStaticPage';
import AboutStaticPage from './StaticPages/AboutStaticPage';
import PoliciesStaticPage from './StaticPages/PoliciesStaticPage';
import NotFound from '../components/NotFound';
import ClinicPaid from '../components/StaticPages/ClinicPaid';
import InternalServerError from '../components/InternalServerError';
import ServiceUnavailable from '../components/ServiceUnavailable';
import ScrollToTop from '../components/ScrollToTop';
import store, { history } from '../store';
import Footer from './Footer';
import Modals from '../containers/Modals';
import styles from './App.css';

const App = () => ({
  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          <div className={styles.app}>
            <Modals />
            <div className={styles.mainWrap}>
              <Switch>
                <Route path="/cart" component={CartPage} />
                <Route path="/confirmation" component={OrderConfirmPage} />
                <Route path="/contact" component={ContactUsStaticPage} />
                <Route path="/about" component={AboutStaticPage} />
                <Route path="/policies" component={PoliciesStaticPage} />
                <Route path="/412" component={ClinicPaid} />
                <Route path="/500" component={InternalServerError} />
                <Route path="/503" component={ServiceUnavailable} />
                <Route
                  exact
                  path="/lookup/:lastName/:rxNumber"
                  component={Lookup}
                />
                <Route exact path="/" component={HomePage} />
                <Route component={NotFound} />
              </Switch>
              <ScrollToTop />
            </div>
            <Footer />
          </div>
        </Router>
      </Provider>
    );
  },
});

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx